var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base"},[_c('inside-header'),_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cloud.title)+" ")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.cloud.content)}})]),_c('main-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }